
import fs from 'fs';

const fileExists = function fileExists(file) {
  try {
    return (!!fs.statSync(file));
  } catch (error) {
    return false;
  }
};

export {
  fileExists, // eslint-disable-line import/prefer-default-export
};
